import { Shark } from "shark-mvc";

import ContentViewBase from "../ContentViewBase";
import TextContent from "../../models/TextContent";

import templateContent from "./text-content.html";

import aiTagSuggestionComponent from "../../components/aiTagSuggestion/aiTagSuggestionComponent";
import contentFinderComponent from "../../components/contentFinder/contentFinderComponent";
import customTagsComponent from "../../components/customTags/customTagsComponent";
import dashboardView from "../dashboard/dashboardView";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import textContentManager from "../../controllers/textContentManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import tagsComponent from "../../components/tags/tagsComponent";
import userMetadataBoxComponent from "../../components/userMetadataBox/userMetadataBoxComponent";

class TextContentView extends ContentViewBase {
	constructor () {
		super("textContentView");
		this.setTemplate(templateContent);
	}

	afterLoad () {
		super.afterLoadCommon(true);

		const { currContent } = Shark.get();

		if (currContent) {
			this.setupEditor();
		}

		if (!this.tagProcessed) {
			this.processTags();
		}
	}

	beforeLoad () {
		this.tagProcessed = false;
		super.beforeLoad(textContentManager, TextContent);
	}

	contentLoaded () {
		Shark.render();
		this.setupEditor();
		waitBoxComponent.close();
	}

	deleteContent (guid) {
		waitBoxComponent.open();

		textContentManager.delete({guid})
		.then(() => {
			waitBoxComponent.close();
			Shark.openPage(dashboardView, { urlSearchParams: null });
		});
	}

	init () {
		this.addComponents([aiTagSuggestionComponent, contentFinderComponent, customTagsComponent, mainNavComponent, tagsComponent, userMetadataBoxComponent, waitBoxComponent]);
		super.init();

		const aiTransform = Shark.getInstance("__smart__", {
			ageTarget: "",
			transformType: "",
		});

		Shark.set({
			aiTransform,
			aiTransformResult: "Fai la tua richiesta",
		});
	}

	async saveCurrContent () {
		await this.save();

		if (Shark.$store.editContentGoBackPage) {
			Shark.openPage(Shark.$store.editContentGoBackPage);
		}
		else {
			Shark.openPage(dashboardView);
		}
	}

	async saveCurrContentAndCreateNew () {
		await this.save();

		const referenceVolumes = Shark.$store.currContent.referenceVolumes;
		const referenceVolumeGuids = Shark.$store.currContent.referenceVolumeGuids;
		
		Shark.set({
			currContent: new TextContent({
				createdByGuid: Shark.$store.currUser.guid,
				referenceVolumes,
				referenceVolumeGuids,
			}),
			isCreatingNewContent: true,
		});
		Shark.openPage(textContentView, { urlSearchParams: null });
	}

	async save () {
		const { currContent } = Shark.get();

		if (currContent) {
			waitBoxComponent.open();
			currContent.set({
				body: Shark.$store.__contentViewTinymceEditor.getContent(),
				textBody: Shark.$store.__contentViewTinymceEditor.getContent({format: "text"}),
			});

			textContentManager.save(currContent)
			.then(async saveResponse => {
				console.log({saveResponse});

				const customTagSaveResult = await customTagsComponent.save();
				console.log({customTagSaveResult});

				waitBoxComponent.close();
			});
		}
	}

	aiTransformBtn_clickHandler () {
		const { aiTransform, currContent } = Shark.get();
		Shark.set({
			aiTransformResult: "...attendi l'elaborazione...",
		});
		
		if (aiTransform && currContent) {
			if (aiTransform.transformType === "" || aiTransform.ageTarget === "") {
				Shark.set({
					aiTransformResult: "Devi impostare tutti i parametri per procedere.",
				});
				return;
			}
			
			const request = `Elabora il testo che ti passo ${aiTransform.transformType} adatto ad ${aiTransform.ageTarget}`;

			console.log({request});

			fetch(`${Shark.$store.apiURL}/v2/ai/text-transform`, {
				body: JSON.stringify({
					content: currContent.textBody,
					request,
				}),
				headers: {
					"Content-Type": "application/json",
				},
				method: "POST",
			})
			.then(response => response.json())
			.then(data => {
				console.log(data);
				Shark.set({
					aiTransformResult: data.data.choices[0].message.content,
				});
			});
		}
	}
}

const textContentView = new TextContentView();

Shark.registerView(textContentView);

export default textContentView;
